import type { ICurrency } from "@/user-account/types/UserAccount.type"
import { ref } from "vue"

const currencies = ref([])
const loading = ref(false)

export function useCurrencies() {
  function setCurrencies(_currencies) {
    _currencies.forEach((currency) => {
      currency.icon = currency.ticker.toLowerCase()
    })
    currencies.value = _currencies
  }

  function ticker(id: number) {
    const cc: ICurrency = currencies.value.find((c: ICurrency) => c.id === id)
    return cc ? cc.ticker : "Unknown"
  }

  function places(id: number) {
    const cc: ICurrency = currencies.value.find((c: ICurrency) => c.id === id)
    return cc.places
  }

  function name(id: number) {
    const cc: ICurrency = currencies?.value?.find((c: ICurrency) => c?.id === id)
    return cc?.name
  }

  function exchangeRate(id: number) {
    const cc: ICurrency = currencies.value.find((c: ICurrency) => c.id === id)
    return cc.exchangeRate
  }

  function getDefaultCurrency() {
    return currencies.value.find(currency => currency.default)
  }

  function currencyByTicker(ticker: string) {
    const cc: ICurrency = currencies.value.find((c: ICurrency) => c.ticker === ticker)
    return cc
  }

  function getIconByTicker($ticker) {
    switch ($ticker) {
      case "USD":
        return "/assets/images/currencies/usd.svg"
      case "EUR":
        return "/assets/images/currencies/eur.svg"
      case "TRY":
        return "/assets/images/currencies/try.svg"
      case "BTC":
        return "/assets/images/currencies/btc-c.svg"
      case "ETH":
        return "/assets/images/currencies/eth-c.svg"
      case "USDTT":
        return "/assets/images/currencies/usdt.svg"
      case "USDTE":
        return "/assets/images/currencies/usdt.svg"
      case "USDC":
        return "/assets/images/currencies/usdc.svg"
      case "NGN":
        return "/assets/images/currencies/ngn.svg"
      case "BNB-BSC":
        return "/assets/images/currencies/bnb.svg"
      case "XRP":
        return "/assets/images/currencies/xrp.png"
      case "ADA":
        return "/assets/images/currencies/cardano.svg"
      case "LTC":
        return "/assets/images/currencies/litecoin.png"
      case "SOL":
        return "/assets/images/currencies/solana.svg"
      default:
        return ""
    }
  }

  return {
    loading,
    currencies,
    setCurrencies,
    exchangeRate,
    name,
    currencyByTicker,
    ticker,
    places,
    getDefaultCurrency,
    getIconByTicker,
  }
}
